import { useEffect } from "react";

// Shared dashboard behavior (defect ledger SH-003): calendars/time pickers must
// open when the user clicks anywhere in the field, not only on the tiny native
// indicator icon. This delegated listener covers every native
// <input type="date|time"> in the app in one place. The long-term pattern is
// the shared CalendarDateInput component; this guarantees the click behavior
// for the remaining native inputs until each module adopts it.
const NativeDatePickerClickOpener = () => {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLInputElement | null;
      if (
        !target ||
        target.tagName !== "INPUT" ||
        (target.type !== "date" && target.type !== "time") ||
        target.disabled ||
        target.readOnly
      ) {
        return;
      }
      try {
        target.showPicker?.();
      } catch {
        // Some browsers throw if the picker cannot open (e.g. not user-gesture
        // driven); the native indicator icon still works as a fallback.
      }
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  return null;
};

export default NativeDatePickerClickOpener;
